import Vue from "vue";
import Router from "vue-router";
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
import StarterFooter from "./layout/starter/StarterFooter"
import StarterHeader from "./layout/starter/StarterHeader"
import Components from "./views/Components.vue";
import Landing from "./views/Landing.vue";
import Login from "./views/Login.vue";
import Register from "./views/Register.vue";
import Profile from "./views/Profile.vue";
import Secure from "./views/Secure.vue";

import BCard from 'bootstrap-vue/es/components/card/card'
import BCardBody from 'bootstrap-vue/es/components/card/card-body'
import BCardFooter from 'bootstrap-vue/es/components/card/card-footer'
import BCardHeader from 'bootstrap-vue/es/components/card/card-header'
import BCardImg from 'bootstrap-vue/es/components/card/card-img'
import BCardText from 'bootstrap-vue/es/components/card/card-text'
import BTable from 'bootstrap-vue/es/components/table/table'
import BButton from 'bootstrap-vue/es/components/button/button'

// Add components globally
Vue.component('b-card', BCard)
Vue.component('b-button', BButton)
Vue.component('b-card-body', BCardBody)
Vue.component('b-card-footer', BCardFooter)
Vue.component('b-card-header', BCardHeader)
Vue.component('b-card-img', BCardImg)
Vue.component('b-table', BTable)
Vue.component('b-card-text', BCardText)

Vue.use(Router);



let router =  new Router({
  linkExactActiveClass: "active",
  routes: [
    {
      path: "/",
      name: "components",
      components: {
        header: StarterHeader,
        default: Landing,
        footer: StarterFooter
      }
    },
    {
      path: "/",
      name: "landing",
      components: {
        header: StarterHeader,
        default: Components,
        footer: StarterFooter
      }
    },
    {
      path: "/login",
      name: "login",
      components: {
        header: StarterHeader,
        default: Login,
        footer: StarterFooter
      }
    },
    {
      path: "/secure",
      name: "secure",
      components: {
        header: StarterHeader,
        default: Secure,
        footer: StarterFooter
      },
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: "/register",
      name: "register",
      components: {
        header: StarterHeader,
        default: Register,
        footer: StarterFooter
      }
    },
    {
      path: "/profile",
      name: "profile",
      components: {
        header: AppHeader,
        default: Profile,
        footer: AppFooter
      }
    }
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});

router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.token != "") {
      next()
      return
    }
    next('/login') 
  } else {
    next() 
  }
})

export default router;

